import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Hero from './components/Hero';
import Needs from './components/Needs';
import Overview from './components/Overview';
import Value from './components/Value';
import Summary from './components/Summary';
import Consultation from './components/Consultation';

export default function SmartFarmSolution() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="智慧农场解决方案｜农产品溯源与数字货架上行｜华辉数智"
        description="华辉数智智慧农场解决方案，以农业生产为基础、数字技术为支撑、市场需求为牵引，融合农田物联感知、TOMA 智能体、ePin 数字身份与数字货架能力，助力农场、合作社和县域农业实现从生产到流通的全链路数字化运营。"
        keywords="智慧农场,农业物联网,农产品溯源,数字货架,农业数字化"
        path="/solutions/smart-farm-solution"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '智慧农场解决方案',
          description:
            '华辉数智智慧农场解决方案，融合农田物联感知、AI 农事管理、ePin 品质追溯、数字货架与供应链协同，助力农业全链路数字化运营。',
        }}
      />

      <Hero />
      <Breadcrumb
        items={[{ label: '产品与解决方案' }, { label: '解决方案' }, { label: '智慧农场' }]}
      />

      <main>
        <Needs />
        <Overview />
        <Value />
        <Summary />
        <Consultation />
      </main>

      <Footer />

      <a
        href="#consultation"
        className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-accent-500 text-foreground-950 text-sm font-medium shadow-[0_8px_24px_rgba(0,0,0,0.18)] whitespace-nowrap cursor-pointer transition-all hover:bg-accent-400 hover:-translate-y-0.5"
      >
        <i className="ri-customer-service-2-line"></i>
        咨询方案
      </a>
    </div>
  );
}